import { combineReducers } from 'redux';
import { tagsReducer } from 'redux/tags';
import { marketPriceReducer } from 'redux/marketPrice';
import { companyJobsReducer } from './companyJobs';
import { mappingReducer } from './mapping';
import { userReducer } from './user';
import { currencyPlansReducer } from './currencyPlans';
import { notificationsReducer } from './notifications';
import { dataManagementReducer } from './dataManagement';

const rootReducer = combineReducers({
  user: userReducer,
  tags: tagsReducer,
  marketPrice: marketPriceReducer,
  companyJobs: companyJobsReducer,
  mapping: mappingReducer,
  currencyPlans: currencyPlansReducer,
  notifications: notificationsReducer,
  dataManagement: dataManagementReducer,
});

export type RootState = ReturnType<typeof rootReducer>

export default rootReducer;
